import Vue from 'vue'

/**
 * 客服事件总线
 * ------------------------------------------------------------------
 * 官网右下角的售前客服是挂在布局里的一个固定组件（PresaleChat），
 * 但页面里到处都需要「带着问题把它叫起来」：帮助中心搜索没命中、
 * 定价页问套餐、物流页问清关……这些组件和客服之间没有父子关系。
 *
 * 用一个空 Vue 实例当总线，任何地方 `openChat('问题')` 就能唤起客服并
 * 自动把这句话发出去，不需要把客服组件塞进每个页面。
 */
export const chatBus = new Vue()

/**
 * 打开 AI 客服
 * @param {string} question 可选，带过去直接发问（用户不用再打一遍）
 */
export function openChat (question) {
  chatBus.$emit('open-chat', String(question || ''))
}
